import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';
import {formatPackageDurationLabel} from '../cellcomAbroadUtilities';

const SelectedDatesAreNotSupportedInPackagePopupContent = (props) => {
  const {selectedCountries} = props;

  const removeSelectedPackage = () => {
    switch (props.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams
            .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .category,
          gaParams
            .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventType,
          gaParams
            .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventParams
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERSEARCHMORE_CLICK.category,
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERSEARCHMORE_CLICK.eventType,
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERSEARCHMORE_CLICK.eventParams
          );
        } else {
          gaEvent(
            gaParams
              .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .category,
            gaParams
              .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventType,
            gaParams
              .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_PARAMETERS_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventParams
          );
        }
        break;
      default:
        break;
    }
    props.setSelectedAbroadPackage(null);
    props.closeModal();
    props.saveToHistory();
    props.dispatchSearching();
  };
  const continueWithSelected = () => {
    switch (props.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams
            .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .category,
          gaParams
            .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventType,
          gaParams
            .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventParams
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERCONTINUEWITHPACKAGE_CLICK.category,
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERCONTINUEWITHPACKAGE_CLICK.eventType,
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERCONTINUEWITHPACKAGE_CLICK.eventParams
          );
        } else {
          gaEvent(
            gaParams
              .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .category,
            gaParams
              .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventType,
            gaParams
              .ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventParams
          );
        }
        break;
      default:
        break;
    }
    props.getNextStep(true);
  };

  return (
    <Container className='not-supported-dates-popup p-0'>
      <Row className='not-supported-dates-popup__upper-text'>
        <Col xs={12} className='text-center'>
          <span className='d-block'>
            משך החבילה שבחרתם{' '}
            <span className='bold'>
              ל-{formatPackageDurationLabel(props.packagePeriod, props.packageDurationUnit)}
            </span>{' '}
            <br />
            קצר יותר מטווח התאריכים שסימנתם
          </span>
        </Col>
      </Row>
      <Row className='not-supported-dates-popup__middle-text'>
        <Col xs={12} className='text-center'>
          <span className='bold'>אז מה אפשר לעשות?</span>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className='text-center mb-2'>
          <span className='bold d-block newPurple'>
            לבחור חבילה שתכלול את טווח התאריכים <br />
            {selectedCountries?.length > 0 && <span>והיעדים שסימנתם:</span>}
          </span>
          {selectedCountries?.length > 0 && (
            <span className='d-block'>
              {selectedCountries.map((country, index) => {
                return (
                  <span className='newPurple ml-1' key={index}>
                    <bdi>{country.countryHebName}</bdi>
                    {index < selectedCountries.length - 1 ? ',' : ''}
                  </span>
                );
              })}
            </span>
          )}
        </Col>
      </Row>
      <Row>
        <Col className='mb-3'>
          <BtnRightSideText
            text={`לבחירת חבילה חדשה`}
            isDisplayArrows={true}
            onclick={() => removeSelectedPackage()}
            customClass={'not-supported-dates-popup__button'}
          />
        </Col>
      </Row>
      <Row className='not-supported-dates-popup__gray-button-row'>
        <Col className={`${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'col-12' : 'col-2 p-0'}`}>
          <span className='ORasBtn'>או</span>
        </Col>
        <Col className={`${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'col-12' : 'col-10'}`}>
          <BtnRightSideText
            text={`המשך עם החבילה שבחרתם`}
            isGreyBg={true}
            isDisplayArrows={true}
            onclick={() => continueWithSelected()}
            customClass='not-supported-dates-popup__gray-button'
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SelectedDatesAreNotSupportedInPackagePopupContent;
